import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "~/hooks/reduxHooks";
import { getFlatPageMapping } from "~/locationMaps";
import { updatePageButtons } from "~/store/layoutSlice";

// regex match return first match
const getPageButtons = (path: string, flatPageMapping: { [key: string]: PageMapping }) => {
	const match = Object.keys(flatPageMapping).find((key) => {
		return new RegExp(key + "$").test(path);
	});
	return match && flatPageMapping[match] ? flatPageMapping[match].buttons : [];
};

const usePageButtons = (): void => {
	const dispatch = useAppDispatch();
	const location = useLocation();
	const application = useAppSelector((state) => state.layout.application);
	const flatPageMapping = useMemo(() => getFlatPageMapping(application), [application]);

	useEffect(() => {
		const path = location.pathname;
		const pageButtons = getPageButtons(path, flatPageMapping);
		dispatch(updatePageButtons(pageButtons));
	}, [location.pathname, flatPageMapping]);
};

export default usePageButtons;
